// Auto generated file, do not manually modify!
// com.hotpads.customeranalytics.enums.AnalyticsAnnualIncomeBucket

export enum AnalyticsAnnualIncomeBucket {
  BRACKET_0_40K = 'BRACKET_0_40K',
  BRACKET_120K_160K = 'BRACKET_120K_160K',
  BRACKET_160K_PLUS = 'BRACKET_160K_PLUS',
  BRACKET_40K_60K = 'BRACKET_40K_60K',
  BRACKET_60K_80K = 'BRACKET_60K_80K',
  BRACKET_80K_120K = 'BRACKET_80K_120K',
}

export const AnalyticsAnnualIncomeBucket_values = [
  AnalyticsAnnualIncomeBucket.BRACKET_0_40K,
  AnalyticsAnnualIncomeBucket.BRACKET_120K_160K,
  AnalyticsAnnualIncomeBucket.BRACKET_160K_PLUS,
  AnalyticsAnnualIncomeBucket.BRACKET_40K_60K,
  AnalyticsAnnualIncomeBucket.BRACKET_60K_80K,
  AnalyticsAnnualIncomeBucket.BRACKET_80K_120K,
] as const;
